import { jsx as g } from "react/jsx-runtime";
import { c as x } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const o = {
  display: "font-display text-5xl font-extrabold tracking-tighter leading-[1.1] lg:text-6xl xl:text-7xl",
  h1: "font-display text-4xl font-extrabold tracking-tighter leading-[1.15] lg:text-5xl",
  h2: "font-display text-3xl font-bold tracking-tight leading-[1.2]",
  h3: "font-display text-2xl font-bold tracking-tight leading-[1.25]",
  h4: "font-display text-xl font-semibold tracking-tight leading-[1.3]",
  h5: "font-display text-lg font-semibold tracking-tight leading-[1.35]",
  h6: "font-display text-base font-semibold tracking-tight leading-[1.4]",
  "body-lg": "text-lg leading-relaxed",
  body: "text-base leading-7",
  small: "text-sm font-medium leading-snug",
  caption: "text-xs text-muted-foreground leading-normal",
  overline: "text-[11px] font-semibold uppercase tracking-wider text-muted-foreground",
  label: "text-xs font-medium uppercase tracking-wider",
  code: "rounded bg-muted px-1.5 py-0.5 font-mono text-sm leading-normal"
}, c = {
  display: "h1",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  "body-lg": "p",
  body: "p",
  small: "p",
  caption: "span",
  overline: "span",
  label: "span",
  code: "code"
}, k = ({
  variant: e = "body",
  children: l,
  className: a,
  as: t,
  color: i,
  display: d,
  gradient: r,
  ...s
}) => {
  const n = Object.prototype.hasOwnProperty.call(o, e) ? e : "body", p = c[n] ?? "p";
  return /* @__PURE__ */ g(
    typeof t == "string" || typeof t == "function" || typeof t == "object" && t !== null ? t : p,
    {
      className: x(
        o[n],
        d && "font-display",
        r && "bg-gradient-primary bg-clip-text text-transparent",
        i,
        a
      ),
      ...s,
      children: l
    }
  );
};
export {
  k as T
};
